// Módulos
import { MatTableDataSource } from '@angular/material/table';
import { Component, Input, Output, EventEmitter } from '@angular/core';

// Helpers
import { ITablePaginator } from '@shared/helpers/table.helper';

@Component({
    selector: 'sbi-cot-table-paginator',
    templateUrl: './table-paginator.component.html',
    styleUrls: ['./table-paginator.component.scss'],
    standalone: false
})
export class TablePaginatorComponent {
  // Inputs
  @Input() dataSource: MatTableDataSource<any>;
  @Input() currentPage: number;
  @Input() itemsPerPage: number;
  @Input() tablePaginator: ITablePaginator[];
  @Input() totalTableItems: number;

  // Outputs
  @Output() onPaginate = new EventEmitter<ITablePaginator>();

  // Constructor
  constructor() {}

  // Al hacer clicke en un elemento del paginador
  public onPaginationItemClicked(item: ITablePaginator): void {
    this.onPaginate.emit(item);
  }
}
